import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../axios";
import { createErrorReportingAsyncThunk } from "../helpers";
import mapValues from "lodash/mapValues";
import { FeatureName } from "dora-contracts";

const prefix = "features";

type Feature = { enabled: boolean };
type State = {
  features: Partial<Record<FeatureName, Feature>>;
  initialLoad: boolean;
};

const initialState: State = {
  features: {},
  initialLoad: false,
};

export const initialize = createErrorReportingAsyncThunk(
  `${prefix}/initialize`,
  async (_: void, { dispatch }) => {
    const { data } = await axios.get("/api/features");
    if (typeof data !== "object") return;
    const features = mapValues(data, (v) => ({
      enabled: !!v.enabled,
    })) as Record<FeatureName, Feature>;
    dispatch(slice.actions.setFeatures(features));
  }
);

const slice = createSlice({
  initialState,
  name: prefix,
  reducers: {
    setFeatures: (_, action: PayloadAction<State["features"]>) => {
      return {
        features: action.payload,
        initialLoad: true,
      };
    },
  },
});

export const { setFeatures } = slice.actions;
export default slice.reducer;
